<template>
  <div>
    <md-table v-model="users" class="md-table-global-users">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="">
          <div class="flag">
            <img :src="item.flag" />
          </div>
        </md-table-cell>
        <md-table-cell md-label="签约院校">{{ item.course }}</md-table-cell>
        <md-table-cell md-label="签约院校">{{ item.users }}</md-table-cell>
        <md-table-cell md-label="签约院校">{{ item.update }}</md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
export default {
  name: "global-users-table",
  data() {
    return {
      selected: [],
      users: [
        {
          flag: "./img/flags/class.png",
          course: "建筑设备监控系统",
          users: "2920",
          update: "2022-8-22",
        },
        {
          flag: "./img/flags/task.png",
          course: "电气控制与PLC应用技术",
          users: "1300",
          update: "2022-8-23",
        },
        {
          flag: "./img/flags/class.png",
          course: "供配电技术",
          users: "760",
          update: "2022-8-24",
        },
        {
          flag: "./img/flags/task.png",
          course: "城轨车站机电环控系统",
          users: "690",
          update: "2022-8-25",
        },
        {
          flag: "./img/flags/class.png",
          course: "液压与气压传动技术",
          users: "600",
          update: "2022-8-26",
        },
        {
          flag: "./img/flags/class.png",
          course: "电力电子技术",
          users: "550",
          update: "2022-8-27",
        },
      ],
    };
  },
};
</script>
